import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import VueScrollTo from 'vue-scrollto'
import { pushVirtualPageView } from '@modules/analytics'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: 'route-active',
  linkExactActiveClass: 'exact-route-active',
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import(/* webpackChunkName: "home" */ './views/HomeView.vue')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import(/* webpackChunkName: "login" */ './views/LoginView.vue')
    },
    {
      path: '/new-password/:token/:email/:firstTime',
      name: 'New Password',
      component: () => import(/* webpackChunkName: "new-password" */ './views/NewPasswordView.vue'),
      props: true
    },
    {
      path: '/contacts',
      name: 'Contacts',
      component: () => import(/* webpackChunkName: "contacts" */ './views/ContactsView.vue'),
      children: [
        {
          path: 'list',
          name: 'Contacts List',
          component: () => import(/* webpackChunkName: "contacts-list" */ './views/ContactsListView.vue'),
          children: [
            {
              props: true,
              path: 'details/:userId',
              name: 'Contact Details',
              component: () => import(/* webpackChunkName: "contacts-user-detail" */ './views/ContactsUserDetailsView.vue')
            }
          ]
        },
        {
          path: 'groups-teams',
          name: 'Groups & Teams',
          component: () => import(/* webpackChunkName: "contacts-groups" */ './views/ContactsGroupsView.vue'),
          children: [
            {
              props: true,
              path: 'details/:groupId',
              name: 'Group Details',
              component: () => import(/* webpackChunkName: "contacts-group-detail" */ './views/ContactsGroupDetailsView.vue')
            }
          ]
        }
      ]
    },
    {
      path: '/calendar',
      name: 'Calendar',
      component: () => import(/* webpackChunkName: "calendar-view" */ './views/CalendarView.vue'),
      redirect: '/calendar/calendar-view',
      children: [
        {
          path: 'calendar-view',
          name: 'Calendar View',
          component: () => import(/* webpackChunkName: "calendar-view" */ './views/CalendarDefaultView.vue')
        },
        {
          path: 'calendar-list',
          name: 'Agenda List View',
          component: () => import(/* webpackChunkName: "calendar-list-view" */ './views/CalendarListView.vue')
        },
        {
          path: 'calendar-table',
          name: 'Agenda Table View',
          component: () => import(/* webpackChunkName: "calendar-table-view" */ './views/CalendarTableView.vue')
        },
        {
          path: 'event/:eventId',
          name: 'Event Detail',
          component: () => import(/* webpackChunkName: "event-detail" */ './views/CalendarDetailView.vue')
        },
        {
          path: 'events/:eventId',
          name: 'Event Detail',
          component: () => import(/* webpackChunkName: "event-detail" */ './views/CalendarDetailView.vue')
        }
      ]
    },
    {
      path: '/documents',
      name: 'Documents',
      component: () => import(/* webpackChunkName: "documents" */ './views/DocumentsView.vue'),
      children: [
        {
          path: 'list',
          name: 'Documents List',
          component: () => import(/* webpackChunkName: "documents-list" */ './views/DocumentsListView.vue')
        },
        {
          path: 'toolbox',
          name: 'Toolbox',
          component: () => import(/* webpackChunkName: "content-view" */ './views/ContentView.vue')
        }
      ]
    },
    {
      path: '/about',
      name: 'About',
      component: () => import(/* webpackChunkName: "about" */ './views/AboutView.vue'),
      children: [
        {
          path: 'croplife-structure',
          name: 'CropLife Structure',
          meta: {
            service: 'croplife-structure'
          },
          component: () => import(/* webpackChunkName: "content-page" */ './views/ContentView.vue')
        },
        {
          path: ':slug',
          name: 'Page',
          meta: {
            service: 'page'
          },
          component: () => import(/* webpackChunkName: "content-page" */ './views/ContentView.vue')
        }
      ]
    },
    {
      path: '/profile',
      name: 'Profile',
      component: () => import(/* webpackChunkName: "myspace" */ './views/ProfileView.vue')
    },
    {
      path: '/my-holidays',
      name: 'My Holidays',
      component: () => import(/* webpackChunkName: "my-holidays" */ './views/HolidaysView.vue')
    },
    {
      path: '/my-travels',
      name: 'My Travels',
      component: () => import(/* webpackChunkName: "my-travels" */ './views/TravelsView.vue')
    },
    {
      path: '/search',
      name: 'Search Results',
      component: () => import(/* webpackChunkName: "search" */ './views/SearchView.vue')
    },
    {
      path: '/my-space',
      name: 'MySpace',
      component: () => import(/* webpackChunkName: "search" */ './views/MySpaceView.vue')
    },
    {
      path: '/my-remote-working',
      name: 'My Remote Working',
      component: () => import(/* webpackChunkName: "my-remote-working" */ './views/RemoteWorkingView.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  VueScrollTo.scrollTo(document)

  if (to.path !== '/search') {
    store.dispatch('filters/updateSearch', { value: '' })
  }

  if (to.path !== '/contacts' && to.path !== '/documents' && to.path !== '/about') {
    pushVirtualPageView(to.name, to.path)
  }

  if (store.getters['auth/getIsLoggedIn']) {
    if (to.name === 'Login' || to.name === 'New Password') next('/')
    else next()
    return
  }
  if (to.name === 'New Password' || to.name === 'Login') {
    next()
  } else {
    store.dispatch('auth/updateOriginalRoute', to.path)
    next('/login')
  }
  //
})

export default router
